import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';

type Props = {
  id: string;
  insertionOrders?: { _id: string; name: string }[];
  onFilterStatus?: (state: { id: string; value: any }[]) => { id: string; value: any }[];
  value?: string[];
};

export default function InsertionOrder({ id, insertionOrders, onFilterStatus, value }: Props) {
  const { formatMessage } = useIntl();

  const options: SelectorOptionPropsInterface[] =
    insertionOrders?.map(({ _id, name }) => ({
      id: _id,
      label: name
    })) || [];

  const selectedValue: SelectorOptionPropsInterface[] =
    insertionOrders
      ?.filter(({ _id }) => value?.includes(_id))
      ?.map(({ _id, name }) => ({
        id: _id,
        label: name
      })) || [];

  const handleChange = (changedSelectedOptions: SelectorOptionPropsInterface[]) => {
    onFilterStatus?.([
      {
        id: 'insertionOrders',
        value: changedSelectedOptions.length
          ? changedSelectedOptions.map(({ id: selectedOptionId }) => selectedOptionId.toString())
          : undefined
      }
    ]);
  };

  return (
    <Selector<SelectorOptionPropsInterface[]>
      id={`${id}_selector`}
      label={formatMessage({
        defaultMessage: 'Insertion Order',
        id: 'campaignPlans.filters.insertionOrder'
      })}
      onChange={handleChange}
      options={options}
      showDeselectOption
      showSelectedItems={false}
      type="multiple"
      value={selectedValue}
    />
  );
}
